<template>
    <DsModal
        center
        show-back
        size="med"
        :is-open="isOpen"
        :title="editorTitle"
        @back="closeModal"
    >
        <template #header>
            <DsFilledButton
                data-qa="save-button"
                @click="updateConfig"
            >
                {{ $t('funnel.campaign.task.outcome.save') }}
            </DsFilledButton>
        </template>
        <DsInputField
            v-model="name"
            data-qa="task-outcome-title"
            :label="$t('funnel.campaign.create.task.title.input')"
            :submitted="invalidName"
            required
        >
            <template #error>
                {{ $t('funnel.campaign.task.outcome.required') }}
            </template>
        </DsInputField>
        <DsMultiselect
            v-model="category"
            data-qa="task-outcome-category"
            :placeholder="$t('funnel.campaign.task.outcome.category.select')"
            :add-text="addCategoryLabel"
            :options="categoryOptions"
            :no-results-label="$t('funnel.campaign.create.task.empty.outcomes')"
            show-blank
            searchable
            :allow-add="isCategoryToAdd"
            @add="addNewCategory"
            @updateSearch="handleInputChange"
        />
    </DsModal>
</template>

<script>
import {
    updateOutcome,
    addOutcome,
} from '../task.outcome.api';

export default {
    props: {
        savedElement: {
            type: Object,
            default: () => (undefined),
        },
        suggestedName: {
            type: String,
            default: () => (undefined),
        },
        editing: {
            type: Boolean,
            required: true,
        },
        isOpen: {
            type: Boolean,
            required: true,
        },
        categoryList: {
            type: Array,
            required: true,
        },
    },
    emits: ['close-editor', 'close-reload'],
    data() {
        return {
            id: '',
            name: '',
            category: '',
            newCategoryInput: '',
            invalidName: false,
            categoryOptions: [],
        };
    },
    computed: {
        editorTitle() {
            return this.editing
                ? this.$t('funnel.campaign.task.outcome.new')
                : this.$t('funnel.campaign.task.outcome.new.outcome');
        },
        isCategoryToAdd() {
            return this.newCategoryInput !== '';
        },
        addCategoryLabel() {
            return this.newCategoryInput === ''
                ? this.$t('funnel.campaign.task.outcome.new.category')
                : `${this.$t('funnel.campaign.create.task.outcome.prefix')}${this.newCategoryInput}${this.$t('funnel.campaign.create.task.category.suffix')}`;
        },
    },
    mounted() {
        this.formatOptions();
        this.loadData();
    },
    methods: {
        loadData() {
            if (this.savedElement) {
                this.name = this.savedElement.name;

                if (this.savedElement.category) {
                    this.category = {
                        value: this.savedElement.category.id,
                        label: this.savedElement.category.name,
                    };
                }
            }

            if (this.suggestedName) {
                this.name = this.suggestedName;
            }
        },
        formatOptions() {
            this.categoryOptions = this.categoryList.map((element) => {
                return {
                    value: element.id,
                    label: element.name,
                };
            });
        },
        closeModal() {
            this.$emit('close-editor');
        },
        closeModalAndReload() {
            this.$emit('close-reload', this.id);
        },
        setIsValidName() {
            this.invalidName = this.name === '';
        },
        isValid() {
            this.setIsValidName();

            return !this.invalidName;
        },
        async updateConfig() {
            let result;

            if (this.isValid()) {
                if (this.editing) {
                    const payload = {
                        id: this.savedElement.id,
                        name: encodeURI(this.name.split(',').join('')),
                        category: {
                            id: this.category.value,
                            name: this.category.label,
                        },
                    };

                    result = await updateOutcome(payload);
                } else {
                    const payload = {
                        name: encodeURI(this.name.split(',').join('')),
                        category: {
                            id: this.category.value,
                            name: this.category.label,
                        },
                    };

                    result = await addOutcome(payload);
                }

                this.id = result.id;
                this.closeModalAndReload();
            }
        },
        handleInputChange(value) {
            this.newCategoryInput = value;
        },
        addNewCategory(value) {
            if (value === '') {
                return;
            }

            const categoryToAdd = {
                value: 0,
                label: value,
            };

            this.removeTransientCategories();
            this.category = categoryToAdd;
            this.categoryOptions.push(categoryToAdd);
            this.newCategoryInput = '';
        },
        removeTransientCategories() {
            this.categoryOptions = this.categoryOptions.filter((item) => item.value !== 0);
        },
    },
};
</script>
